import { DataScroller } from "primereact/datascroller";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import rewardModel from "../../static/reward.model";
import { useLocation } from "react-router-dom";
import { getRewards } from "../../service/reward.service";
import { getCatalogs } from "../../service/catalog.service";
import { InputSwitch, InputSwitchChangeEvent } from "primereact/inputswitch";
import { exitFromApplication, getFormatImageFile, goTo, returnCatalogId } from "../../utilities/common.utilities";
import CatalogModel from "../../static/catalog.model";
import './rewardsCatalog.component.css';
import { useConnectivity } from "../../context/connectivityContext";
import { Dialog } from 'primereact/dialog';

import { MultiSelect } from 'primereact/multiselect';


interface RewardCustom {
  id: number;
  code: string;
  name: string;
  description: string;
  image: string;
  price: number;
  points: number;
  pointsprice: number;
  category: string;
}

export default function CatalogRewardsComponent() {
  const location = useLocation();
  // const theme = localStorage.getItem("theme") || "light";

  // Se non sono presenti dati in location.state, reindirizzo in home al posto
  // di far andare in errore il componente
  if(!location.state) {
    goTo('/home');
  }
  
  const {cardData} = location.state;
  const [catalogName, setCatalogName] = useState<string>('')
  const [products, setProducts] = useState<RewardCustom[]>([]);
  const [productsFiltered, setProductsFiltered] = useState<RewardCustom[]>([]);
  const [checked, setChecked] = useState<boolean>(false);
  const [productsFilteredByPoints, setProductsFilteredByPoints] = useState<RewardCustom[]>([]);
  const [searchValue, setSearchValue] = useState<string>('');
  const [catalogList, setCatalogList] = useState<CatalogModel[]>([]);
  const [catalogId, setCatalogId] = useState<string>('');
  const [lastCatalog, setLastCatalog] = useState<number>(0);
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const [endGetRewards, setEndGetRewards] = useState<boolean>(false)

  // Variabile utilizzata per sapere se ci sono errori nella ricezione dei premi come l' assenza di connessione.
  // Utilizzata per distinguere sul template, se la mancanza di premi è dovuta ad errore oppure effettivamente non c'è ne sono.
  const [errorGetRewards, setErrorGetRewards] = useState<boolean>(false);
  const { isOnline } = useConnectivity();

  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);

  const truncateText = (text: string, maxLength: number): string => {
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  const getProducts = () => {
    localStorage.removeItem("GET_REWARDS_TIME")
    localStorage.removeItem("rewards")

    getCatalogs(cardData.groupCode, cardData.storeCode, cardData.selectedCard).then( async (catalogData:CatalogModel[]) => {
      catalogData?.map(x=>{
        if(x?.catalogId > lastCatalog ){
          setLastCatalog(x.catalogId)
        }

      })

      catalogData = catalogData ? catalogData : [];
      setCatalogList(catalogData);
      if(catalogData && catalogData.length > 0){
        const catalogId = await returnCatalogId();
        setCatalogId(catalogId);
        setCatalogName(catalogData.filter(x => x.catalogId.toString() === catalogId)[0].catalogName);

        getRewards(cardData.groupCode, cardData.storeCode, cardData.selectedCard, catalogId).then((rewardsData:rewardModel) => {
          if(!rewardsData) {
            setErrorGetRewards(true);
          }
          else if(rewardsData?.categories?.length > 0){
            let result: RewardCustom[] = [];
            rewardsData.categories.map((x) => {
              x.rewards.map((xx) => {
                result.push({
                  id: xx.id,
                  code: xx.code,
                  name: xx.name,
                  description: xx.description,
                  image: xx.picture? xx.picture.replace('/storage','') : '',
                  price: xx.moneyContribute,
                  points: xx.points,
                  pointsprice: xx.contributePoints,
                  category: x.name, // nome della categoria
                })
              })
            });

            if(result.length > 0){
              setProducts(result);
              setProductsFiltered(result);
            } else {
              setProducts([]);
              setProductsFiltered([]);
            }
          } else {
            setProducts([]);
            setProductsFiltered([]);
          }
          setEndGetRewards(true) //TESTARE
        })
        } else {
          if(navigator.onLine) {
            exitFromApplication();
          }
          else {
            setErrorGetRewards(true);
            setEndGetRewards(true);
          }
        }

    })
  };

  const search = (value: string, isSwitchOn: boolean) => {
    setSearchValue(value);
      // Logica di filtro base su testo e switch
      let tempProducts:RewardCustom[] = [];

      if(isSwitchOn){ // l'utente ha usato lo switch per la ricerca in base ai suoi punti nel catalogo
        const pointsByCatalog: number = catalogList.filter( x => x.catalogId.toString() === catalogId)[0].points;
        const tempProductFilteredByPoints: RewardCustom[] = products.filter(x => x.points <= pointsByCatalog);
        tempProducts = tempProductFilteredByPoints.filter(x => {
          return x.name.toLowerCase().includes(value.toLowerCase()) ||
            x.category.toLowerCase().includes(value.toLowerCase()) ||
            x.code.toLowerCase().includes(value.toLowerCase()) ||
            x.points.toString().toLowerCase().includes(value.toLowerCase()) ||
            x.price.toString().toLowerCase().includes(value.toLowerCase())
        });
      } else {
        tempProducts = products.filter(x => {
          return x.name.toLowerCase().includes(value.toLowerCase()) ||
            x.category.toLowerCase().includes(value.toLowerCase()) ||
            x.code.toLowerCase().includes(value.toLowerCase()) ||
            x.points.toString().toLowerCase().includes(value.toLowerCase()) ||
            x.price.toString().toLowerCase().includes(value.toLowerCase())
          
        });        
      }
    // Filtra ulteriormente in base alle categorie selezionate
    if (selectedCategories.length > 0) {
      tempProducts = tempProducts.filter(p => selectedCategories.includes(p.category));
    }

    setProductsFiltered(tempProducts);
  }

  const setProductByPoints = async (param: boolean) => {
      await setChecked(param);
      search(searchValue, param);
  }
  const [theme, setTheme] = useState<string>(localStorage.getItem("theme") || "light-blue");

  useEffect(() => {
    getProducts();
    const storedTheme = localStorage.getItem("theme") || "light-blue";
    setTheme(storedTheme);

  }, [isOnline]); // Indico di reindirizzare il componente quando la variabile isOnline cambia valore

  const handleCatalogNameClick = (selectedCatalogId: string | number) => {
    // Recupera il valore di "rewards" da localStorage
    const rewardsString = localStorage.getItem("rewards");

    // Verifica se esiste e se è un JSON valido
    if (rewardsString) {
      try {
          const rewards = JSON.parse(rewardsString);

          // Controlla se il catalogId corrisponde
          if (rewards.catalogId === selectedCatalogId ) {
              setShowDialog(true); // Mostra il dialog
          } else {
              console.log("catalogId non corrisponde, dialog non mostrato.");
          }
      } catch (error) {
          console.error("Errore durante il parsing di rewards da localStorage:", error);
      }
    } else {
        console.log("Nessun valore trovato per la chiave 'rewards' in localStorage.");
    }

    // setShowDialog(true);
  };

  const handleDialogClose = () => {
    setShowDialog(false);
  };

  const itemTemplate = (data: RewardCustom) => {

    
    return (
      <div
        className="col-12 bg-white mt-4 p-0 custom-card rewards-catalog-style"
        // style={{ border: "1px solid #a8a8a7", borderRadius: "8px" }}
      >
        <div className="flex flex-column">
          <div className="p-2 flex flex-column" style={{ borderBottom: '1px solid #edecec' }}>
            <img
              src={process.env.REACT_APP_STORAGE_URL + data.image}
              style={{ borderRadius: "8px 8px 0 0" , }}
              alt={data.name}
            />
          </div>

          <div className="p-2 pt-0">
            <div className="flex overflow-hidden">
              <div className="flex-grow-1 flex-column align-items-start justify-content-start mt-1">
                <h2 className="mt-2 mb-0">{data.name}</h2>
                
                  <div className="catalog-name-rewards" >{ catalogName.toUpperCase() }</div> 
                
                {/* <div className="catalog-name-rewards " >{catalogName}</div> */}
              </div>
              <div className="flex-none flex align-items-start justify-content-end mt-2 reward-cat-description">

                <div className="flex flex-column align-content-center justify-content-end">
                  <div className="flex">
                    <i className="flex align-items-center justify-content-center pi pi-tag product-category-icon mr-2 "></i>
                    { data.code === 'BNSC13' 
                      ?
                      <div className="flex align-items-center justify-content-center font-semibold">
                        BUONI
                      </div>
                      :
                      <div className="flex align-items-center justify-content-center font-semibold">
                        {data.category}
                      </div>
                    }
                  </div>
                  <div>
                    <i className="pi pi-hashtag product-category-icon mr-2"></i>
                    <span className="font-semibold ">{data.code}</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="block mt-2">
              <div className="text-justify">
                {data.description}
              </div>
            </div>

            <div className="flex overflow-hidden mt-2">
              <div
                className="flex-grow-1 flex align-items-start justify-content-center p-1 rewards-points-need " >
                <div className="text-2xl font-bold">{data.points}</div>
                <div className="font-bold ml-1 mt-1" style={{ fontSize: "8px" }}>
                  PUNTI
                </div>
              </div>
              { data.price > 0 ?
                <div className="flex-grow-1 flex align-items-center justify-content-center">
                <div className="font-bold" style={{ fontSize: "12px" }}>
                  OPPURE
                </div>
              </div>
              : <div className="flex-grow-1 flex align-items-center justify-content-center"></div>
              }
              { data.price > 0 ?
              <div
                className="flex-none flex align-items-start justify-content-end p-1 rewards-points-money ">
                <div className="flex overflow-hidden">
                  <div className="flex-grow-1 flex align-items-start justify-content-start">
                    <div className="text-2xl font-bold">{data.pointsprice}</div>
                    <div className="font-bold ml-1 mt-1" style={{ fontSize: "8px" }}>
                      PUNTI
                    </div>
                  </div>
                  <div className="flex-none flex align-items-start justify-content-start ml-1 mr-1">
                    <div className="text-2xl font-bold">+</div>
                  </div>
                  <div className="flex-none flex align-items-start justify-content-start">
                    <div className="text-2xl font-bold">{data.price} €</div>
                  </div>
                </div>
              </div>
              : <div className="flex-none flex align-items-start justify-content-end p-1"></div> }
            </div>
          </div>
        </div>
      </div>
    );
  };


  const onSelectCatalog = (catalogId: number) => {
    localStorage.removeItem("GET_REWARDS_TIME")
    localStorage.removeItem("rewards")

    getRewards(cardData.groupCode, cardData.storeCode, cardData.selectedCard, catalogId.toString()).then((rewardsData:rewardModel) => {
      if(rewardsData?.categories?.length > 0){
        let result: RewardCustom[] = [];
        rewardsData.categories.map((x) => {
          x.rewards.map((xx) => {
            result.push({
              id: xx.id,
              code: xx.code,
              name: xx.name,
              description: xx.description,
              image: xx.picture? xx.picture.replace('/storage','') : '',
              price: xx.moneyContribute,
              points: xx.points,
              pointsprice: xx.contributePoints,
              category: x.name, // nome della categoria
            })
          })
        });

        if(result.length > 0){
          setProducts(result);
          setProductsFiltered(result);
        } else {
          setProducts([]);
          setProductsFiltered([]);
        }
      } else {
        setProducts([]);
        setProductsFiltered([]);
      }

      setCatalogId(catalogId.toString());
      setChecked(false);
      setSearchValue('');
      setEndGetRewards(true); // TESTARE
      setCatalogName(rewardsData.catalogName)

      // Azzera le categorie selezionate
      setSelectedCategories([]);

    })
  }

  // Estraggo le categorie uniche dai prodotti (products) per il MultiSelect
  const categories = Array.from(new Set(products.map(p => p.category)));

  // Quando cambia selectedCategories o searchValue o checked, rifiltro i prodotti
  useEffect(() => {
    search(searchValue, checked);
  }, [selectedCategories, checked]);

  return (
    <>
    <div className="mt-2 catalog-dialog rewards-catalog-style filtri-catalogo">
        <div className="flex justify-content-center">
          <h2 className="mt-1 mb-0">Catalogo Premi</h2>
        </div>
        <Dialog
          className="rewards-catalog-style-dialog"
          header={catalogName}
          visible={showDialog}
          style={{ width: "80vw" }}
          onHide={handleDialogClose}
          >
          {/* <b>{catalogName}</b> */}
        </Dialog>
        {
          catalogList.length > 1 ?
          <div className="catalog-name-container flex justify-content-between align-items-center mt-2">
                  {catalogList.map( (item, index) =>
                  
            <div key={item.catalogId} className=" flex-1 align-items-center justify-content-center text-center p-1" style={{cursor:'pointer'}} onClick={() => onSelectCatalog(item.catalogId)}>
                <div className= {" card-catalog " + (catalogId !== item.catalogId.toString() ? "font-bold p-3 notActiveCatalog" : lastCatalog === item.catalogId ? "font-bold p-3 isActiveCatalog " : "font-bold p-3 old-catalogue" ) }>
                  <div className="flex-column">
                    {
                      item.catalogName.length > 37 ?
                      (
                        <div className="" onClick={() => handleCatalogNameClick(item.catalogId)}>{truncateText(item.catalogName.toUpperCase(), 37)}  </div>
                      )
                      :
                      (
                        <div>
                          <div className="">{item.catalogName.toUpperCase()}  </div>
                        </div>
                      )
                    }
                    
                    <hr className={catalogId !== item.catalogId.toString() ? "font-bold notActiveCatalog" : lastCatalog === item.catalogId ? "font-bold isActiveCatalog " : "font-bold old-catalogue" }/>
                  </div>
                  <div className="flex align-items-center justify-content-center p-1 ">
                    <div className="font-bold p-1" style={{fontSize: '1.5rem'}} >{item.points + ' punti'}</div>
                  </div>
                </div>
            </div>

                  
                )}
          </div>
          :
          <h2 className="flex text-center justify-content-center mt-1 mb-2">
          {catalogName}
        </h2>
        }


        { products.length > 0 ?
        <div>

          <div className="flex-column align-items-center justify-content-center ">
            <div className="flex align-items-center justify-content-between overflow-hidden mt-2">
              <div id="cercaCatalog" className="flex-none flex align-items-center justify-content-center ml-3" style={{ width: '70%' }} > {/*style={{ maxWidth: '75%' }}*/}
                <InputText  value={searchValue} placeholder="Cerca" onChange={(e) => search(e.target.value, checked)} />
              </div>

              <div className="flex align-items-center justify-content-end ml-3 mr-3" >
                <div className="flex flex-column">

                  <div className="flex align-items-center justify-content-center">
                    <InputSwitch id="switch" checked={checked} onChange={(e: InputSwitchChangeEvent) => setProductByPoints(e.value)} />
                  </div>

                  <div className="flex text-center flex-wrap align-items-center justify-content-center mt-1">
                      <label style={{ fontSize: '8px', fontWeight: 'bold' }} htmlFor="switch">PRENOTABILI CON I MIEI PUNTI</label>
                  </div>

                </div>

              </div>
            </div>
            
            {/* MultiSelect per le categorie */}
            {products.length > 0 &&  (
              <div className="mt-2 filtri-catalogo" style={{  }}>
                <MultiSelect
                  className={`filtro-categorie-catalogo theme-${theme}`}
                  panelClassName={`style-panel-filtro-categorie theme-${theme}`}
                  value={selectedCategories}
                  options={categories}
                  onChange={(e) => setSelectedCategories(e.value)}
                  placeholder="Filtra per categorie"
                  emptyMessage="Categorie vuote"
                  display="chip"
                  selectAllLabel="Seleziona Tutto"
                  
                  // maxSelectedLabels={2}  
                  // selectedItemsLabel="{0} selezionati"
                />
              </div>
            )}
          </div>

        </div>
          
        : <></> 
      }


        <DataScroller
          className="mb-4"
          value={productsFiltered}
          itemTemplate={itemTemplate}
          rows={1000}
          buffer={0.4}
          header=""
          emptyMessage={
            <div className="text-center text-lg mt-5">
              {
                (products.length === 0 && endGetRewards ) || checked  ?
                  (
                    (!errorGetRewards)
                    ?
                    <div>Nessun Premio trovato</div>
                    :
                    <div className="flex flex-column">

                      {
                        isOnline
                        ?
                        <></>
                        :
                        <div className='mb-3'>
                          <img src="./offline_globe.svg" alt="" className="img-offline-globe-empty-result"></img>
                        </div>
                        
                      }

                      <div>Impossibile caricare i Premi.</div>
                      {
                        navigator.onLine
                        ?
                        <></>
                        :
                        <div>Verifica la connessione internet.</div>
                      }
                    </div>
                  )
                :
                (
                  <></>
                )
              }
            </div>
          }/>
    </div>
    </>
  );
}
